var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.loadComponent,{tag:"component",attrs:{"screen":_vm.screen,"slug":_vm.slug}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }